import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import {
  getAutomationConnList,
  getIsLoadingList
} from './store/selectors/rpa-automation-anywhere-conn.selector';
import {
  AutomationAnywhereConnList,
  GetCurrentAutomationAnywhereConn,
  ResetAutomationAnywhereState
} from './store/actions/rpa-automation-anywhere-conn.actions';
import { AutomationDetailWrapperComponent } from './automation-detail-wrapper/automation-detail-wrapper.component';
import { BotsListComponent } from '../shared/bots-list/bots-list.component';
import {
  RpaBotType,
  EListSelectionStatus
} from 'app/rpa-bots/core/rpa-bots-type.enum';
import { PendingChangesService } from 'app/rpa-bots/core/pending-changes.service';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionAutomationAnywhere } from '../core/IRpaBots';

@Component({
  selector: 'automation-anywhere',
  templateUrl: 'automation-anywhere.component.html',
  styleUrls: ['automation-anywhere.component.scss']
})
export class AutomationAnywhereComponent implements AfterViewInit {
  private _isLoadingListSubscription: Subscription;
  @ViewChild('automationDetailWrapper', { static: false})
  private _automationDetailWrapperComponent: AutomationDetailWrapperComponent;
  @ViewChild('botsList', { static: false}) private _botsList: BotsListComponent;

  automationList$: Observable<IRpaConnectionAutomationAnywhere[]>;
  isLoading$: Observable<boolean>;

  constructor(
    private _store: Store<IAppState>,
    private _pendingChangesService: PendingChangesService
  ) {
    this.automationList$ = this._store.pipe(select(getAutomationConnList));
    this.isLoading$ = this._store.pipe(select(getIsLoadingList));
  }

  ngOnInit() {
    this._store.dispatch(new AutomationAnywhereConnList());
    this._isLoadingListSubscription = this.isLoading$.subscribe(
      (isLoading: boolean) => {
        this._pendingChangesService.afterConnectorUpdated(isLoading);
      }
    );
  }

  ngAfterViewInit() {
    this._pendingChangesService.initialize(
      this._store,
      this._automationDetailWrapperComponent,
      this._botsList,
      RpaBotType.AutomationAnywhere,
      EListSelectionStatus.unselect
    );
  }

  ngOnDestroy(): void {
    this._store.dispatch(new ResetAutomationAnywhereState());
    if (this._isLoadingListSubscription) {
      this._isLoadingListSubscription.unsubscribe();
    }
  }

  onSelectedBotChanged(bot: IRpaConnectionAutomationAnywhere) {
    this._pendingChangesService.listSelectionStatus =
      EListSelectionStatus.loading;
    if (!!this._pendingChangesService.selectedConnector) {
      this._pendingChangesService.nextConnector = bot;
      this._pendingChangesService.check();
    } else {
      this._pendingChangesService.selectedConnector = bot;
      this._botsList.currentBot = bot;
      this._store.dispatch(new GetCurrentAutomationAnywhereConn(bot.id));
    }
  }
}
